"use client";

import { impLogDataAttrs, sendImpLog } from "@lib/analyticLog";
import Image from "next/image";
import { ComponentProps } from "react";

type ImageWithImpLogProps = ComponentProps<typeof Image> & impLogDataAttrs;

function logImp(attrs: impLogDataAttrs) {
  sendImpLog(attrs);
}

export function ImageWithImpLog({ ...attrs }: ImageWithImpLogProps) {
  const i = attrs;
  return (
    <Image
      {...attrs}
      alt={attrs.alt || ""}
      onLoad={() => {
        logImp(attrs);
      }}
    />
  );
}
